import { render, staticRenderFns } from "./WorkFields.vue?vue&type=template&id=201adfba&scoped=true&"
import script from "./WorkFields.vue?vue&type=script&lang=js&"
export * from "./WorkFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201adfba",
  null
  
)

export default component.exports